import React, { useMemo } from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../../../components/AddEditProductFormComponents/FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { useCurrentCloudProvider } from '@labrav/common'
import { CloudType } from '../../../types/index'

const awsFaqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Is the picture shown in the window going to be actually how the buyer registration page looks like?"
      />
    ),
    answer: (
      <div>
        No, this window shows a simple preview of the page. Your actual buyer
        registration page will open in a new screen which the user is redirected
        to. The size of the buyer registration page will be bigger. To
        accommodate the size of the window it has been reduced down.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Where can I see the actual buyer registration page?"
      />
    ),
    answer: (
      <div>
        Once your listing is created, you can view it inside AWS Marketplace.
        Please subscribe to your listing ensuring that the price is not above
        0.01 as it will be charged to you. Once you have subscribed to your
        listing, you will see a button ‘Set up your account’ inside AWS
        Marketplace. Upon clicking that button, you will be redirected to your
        customised buyer registration page which you see in the preview window
        here..
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="There are few things that I want to edit in the form, where can I do that?"
      />
    ),
    answer: (
      <div>
        You can edit all elements of the buyer registration page upon closing
        the Buyer registration page preview window and editing fields in the
        main form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="If I make any edits to the form, can I preview those as well?"
      />
    ),
    answer: (
      <div>
        Yes, you can continue to edit the fields in the main form and the
        preview of the buyer registration page will show the updated version.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Why is my logo not showing up?"
      />
    ),
    answer: (
      <div>
        You need to check if you have added a logo in the ‘Product details’
        form. Once the logo is added, it will be shown in the buyer registration
        page preview.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Why is there a scroll in the form?"
      />
    ),
    answer: (
      <div>
        Since the size of the window in which the preview is shown is small, the
        form has a scroll so you can view the entire form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Why is my background image not coming nicely?"
      />
    ),
    answer: (
      <div>
        This is only a preview of the buyer registration page, due to the small
        size of the window the image may have been cut.
      </div>
    ),
  },
]

const azureFaqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Is the picture shown in the window going to be actually how the buyer registration page looks like?"
      />
    ),
    answer: (
      <div>
        No, this window shows a simple preview of the page. Your actual buyer
        registration page will open in a new screen which the user is redirected
        to. The size of the buyer registration page will be bigger. To
        accommodate the size of the window it has been reduced down.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Where can I see the actual buyer registration page?"
      />
    ),
    answer: (
      <div>
        Once your listing is created, you can view it inside Microsoft
        Marketplace. Please subscribe to your listing ensuring that the price is
        not above 0.01 as it will be charged to you. Once you complete the
        purchase, you will see a button ‘Configure your account now’ inside
        Microsoft Marketplace. Upon clicking that button, you will be redirected
        to your customised buyer registration page which you see in the preview
        window here..
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="There are few things that I want to edit in the form, where can I do that?"
      />
    ),
    answer: (
      <div>
        You can edit all elements of the buyer registration page upon closing
        the Buyer registration page preview window and editing fields in the
        main form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="If I make any edits to the form, can I preview those as well?"
      />
    ),
    answer: (
      <div>
        Yes, you can continue to edit the fields in the main form and the
        preview of the buyer registration page will show the updated version.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Why is my logo not showing up?"
      />
    ),
    answer: (
      <div>
        You need to check if you have added a logo in the ‘Product details’
        form. Once the logo is added, it will be shown in the buyer registration
        page preview.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Why is there a scroll in the form?"
      />
    ),
    answer: (
      <div>
        Since the size of the window in which the preview is shown is small, the
        form has a scroll so you can view the entire form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_PAGE_PREVIEW
        }
        question="Why is my background image not coming nicely?"
      />
    ),
    answer: (
      <div>
        This is only a preview of the buyer registration page, due to the small
        size of the window the image may have been cut.
      </div>
    ),
  },
]

export const BuyerRegistrationPreviewModalHelpAndFaqs = () => {
  const selectedCloud = useCurrentCloudProvider()
  const faqItems = useMemo(() => {
    return selectedCloud === CloudType.AWS ? awsFaqItems : azureFaqItems
  }, [selectedCloud])
  return (
    <HelpDrawerWithAccordion
      headerTitle="Help & FAQs - Buyer registration page preview"
      faqItems={faqItems}
    />
  )
}
